// @ts-nocheck
export const digest = (word: string) => {
    if (!word) return '';
    try {
        const decoded = decodeURIComponent(word.replace(/%(?![0-9A-Fa-f]{2})/g, '%25'));

        let final = decoded
            .trim()
            .replace(/([a-z])([A-Z])/g, '$1-$2') // Add dash between camelCase
            .replace(/&/g, 'and') // Replace '&' with 'and'
            .replace(/%/g, '') // Remove any '%'
            .replace(/[’']/g, '-') // Replace apostrophes with '-'
            .replace(/\(([^)]+)\)/g, '-$1-') // Replace content in parentheses with dashes
            .replace(/…/g, '-') // New rule: Replace ellipses with a dash
            .replace(/[^a-zA-Z0-9\s-]/g, '') // Remove invalid characters
            .replace(/\s+/g, '-') // Replace spaces with '-'
            .replace(/^-+|-+$/g, '') // Remove leading and trailing dashes
            .replace(/--+/g, '-') // Replace multiple dashes with a single dash
            .toLowerCase();

        return final;
    } catch (error) {
        console.error('Malformed URI detected:', word, error);
        return '';
    }
};


export const slugBuilder = (menuTitle, subMenuTitle, title) => {
    let menu = "";
    if (menuTitle != "" && menuTitle != undefined && menuTitle != null) {
        menu = `${digest(menuTitle)}/`
    }
    let subMenu = "";
    if (subMenuTitle != "" && subMenuTitle != undefined && subMenuTitle != null) {
        subMenu = `${digest(subMenuTitle)}/`
    }
    let finalResult = `${menu}${subMenu}${digest(title)}`;
    if (finalResult === "home") finalResult = "/"
    return finalResult;
};
export const crumbBuilder = (menuTitle, subMenuTitle) => {
    const parts = [];

    if (menuTitle) parts.push(menuTitle);
    if (subMenuTitle) parts.push(subMenuTitle);

    return parts.join(' > ');
};

const generateUrls = (posts, vxiContent, termsAndPolicies) => {
    const urls = [];

    // For posts
    posts?.forEach((post) => {
        const slug = slugBuilder(post.attributes.menuTitle, post.attributes.subMenuTitle, post.attributes.title);
        urls.push(slug.toLowerCase());
    });

    // For filteredProcessedVxiContent (if it contains slug-like data)
    vxiContent.forEach((content) => {
        const slug = slugBuilder(content.sections, null, content.title);  // Adjust as necessary for sections
        urls.push(slug.toLowerCase());
    });

    // For termsAndPolicies
    termsAndPolicies?.forEach((terms) => {
        const slug = slugBuilder(null, null, terms?.attributes?.title);  // Adjust for terms
        urls.push(slug.toLowerCase());
    });

    return urls;
};